import { styled, colors, Accordion } from '@mui/material';

export const AccordionStyled = styled(Accordion)(() => ({
  boxShadow: `
  0px 3px 5px -1px #CDCDCD33,
  0px 5px 8px 0px #CDCDCD24,
  0px 1px 14px 0px #CDCDCD1F
`,
  border: `0.5px solid ${colors.grey[200]}`,
  borderRadius: 16,
  '&:first-of-type': {
    borderRadius: 16,
  },
  '&:last-of-type': {
    borderRadius: 16,
  },
  '&:before': {
    display: 'none',
  },
}));
